import { DisplayConditions, CarboneRoadLayoutConfig, CarboneLightingClassConfig } from "./types";

type Params = {
  roadLayoutConfig?: CarboneRoadLayoutConfig;
  lightingClassConfig?: CarboneLightingClassConfig;
  luminance: unknown;
  sidewalk_placing: unknown;
  illuminance: unknown;
  displayLuminance?: boolean;
  displayIlluminance?: boolean;
  projectConfig?: { project_id?: string; name_of_road?: string; comment?: string };
  project?: { project_name?: string; location?: string };
};

export function buildDisplayConditions({
  roadLayoutConfig,
  lightingClassConfig,
  luminance,
  sidewalk_placing,
  illuminance,
  displayLuminance,
  displayIlluminance,
  projectConfig,
  project,
}: Params): DisplayConditions {
  const selectedRoadClass = lightingClassConfig?.roadClasses
    ? lightingClassConfig.roadClasses
    : lightingClassConfig?.customClasses?.mainCustomClass?.class_type || "";

  const showFormData = Boolean(
    projectConfig?.project_id || project?.project_name || project?.location || projectConfig?.name_of_road || projectConfig?.comment
  );

  const isMClass = Boolean(selectedRoadClass && (/^M\d/.test(selectedRoadClass) || /^M/.test(selectedRoadClass)));
  const isPClass = Boolean(selectedRoadClass && (/^P\d/.test(selectedRoadClass) || /^P/.test(selectedRoadClass)));
  const isCClass = Boolean(selectedRoadClass && (/^C\d/.test(selectedRoadClass) || /^C/.test(selectedRoadClass)));
  const isCustomClass = Boolean(lightingClassConfig?.customClasses?.mainCustomClass?.class_type);

  const hasBorderAreaLeft = roadLayoutConfig?.borderAreaLeft || false;
  const hasBorderAreaRight = roadLayoutConfig?.borderAreaRight || false;
  const hasBorderAreas = hasBorderAreaLeft || hasBorderAreaRight;

  const showLuminance = displayLuminance ?? isMClass;
  const showIlluminance = (displayIlluminance ?? (isPClass || isCClass)) || hasBorderAreas;
  const showBorderIlluminance = showLuminance && hasBorderAreas;

  const sidewalkPlacing = typeof sidewalk_placing === "string" ? sidewalk_placing : null;
  const hasSidewalkLeft = sidewalkPlacing === "Left" || sidewalkPlacing === "Both";
  const hasSidewalkRight = sidewalkPlacing === "Right" || sidewalkPlacing === "Both";
  const hasSidewalkBoth = sidewalkPlacing === "Both";

  const laneCount = luminance ? Object.keys(luminance as Record<string, unknown>).length : 0;
  const hasMultipleLanes = laneCount > 1;

  const showLuminanceHeatmap = showLuminance && laneCount > 0;
  const showIlluminanceHeatmap = showIlluminance && Boolean(illuminance);
  const showBorderLeftHeatmap = (showBorderIlluminance || showIlluminance) && hasSidewalkLeft;
  const showBorderRightHeatmap = (showBorderIlluminance || showIlluminance) && hasSidewalkRight;

  return {
    showFormData,
    showLuminance,
    showIlluminance,
    isMClass,
    isPClass,
    isCClass,
    isCustomClass,
    hasBorderAreaLeft,
    hasBorderAreaRight,
    hasBorderAreas,
    showBorderIlluminance,
    sidewalkPlacing,
    hasSidewalkLeft,
    hasSidewalkRight,
    hasSidewalkBoth,
    hasMultipleLanes,
    laneCount,
    showLuminanceHeatmap,
    showIlluminanceHeatmap,
    showBorderLeftHeatmap,
    showBorderRightHeatmap,
    showLeftForLuminance: hasBorderAreaLeft && isMClass,
    showRightForLuminance: hasBorderAreaRight && isMClass,
    showLeftForIlluminance: hasBorderAreaLeft && !isMClass,
    showRightForIlluminance: hasBorderAreaRight && !isMClass,
  };
}
